import React, { useState, useMemo } from 'react';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { isSubAccount } from '../../../consts/multiAccountConfig';

export const LogoutPage = ({ isCommon }) => {
  const handleClose = () => {
    setShow(false);
    // 按钮关闭后直接跳到首页不然留一个空白页面特别尴尬
    setTimeout(() => {
      window.location.hash = '/';
    });
  };
  const onSubmit = () => {
    RPCFactory.sso
      .logout()
      .done((data) => {
        window.location.href = '/';
      })
      .fail((ret, msg) => {
        window.alert(`退出失败，错误信息：${msg}`);
      });
  };
  const [show, setShow] = useState(true);

  const hintBody = useMemo(() => {
    const subaccountHint = (
      <span>该账号是子账号，暂不支持线索转发，请登录其授权的主账号进行线索转发操作。</span>
    );
    const otherHint = (
      <span>
        您暂无权限登录，请使用开户qq登录或联系该账号线索管理平台管理员进行操作，或使用mkt api进行线索转发：
        <a href="https://developers.e.qq.com/docs/api/insights/leads/lead_clues_get">
          https://developers.e.qq.com/docs/api/insights/leads/lead_clues_get
        </a>
      </span>
    );
    const commonHint = (
      <span>您暂无权限登录，请使用开户qq进行登录或联系该账号线索管理平台管理员修改您的角色后再次登录。</span>
    );
    if (isCommon) return commonHint;
    return isSubAccount() ? subaccountHint : otherHint;
  }, [isCommon]);

  return (
    <div className="logout-page">
      <Dialog
        show={show}
        onClose={handleClose}
        onSubmit={onSubmit}
        title=""
        submitLabel="退出登录"
        cancelButton={false}
        className="logout-dialog modal-w500"
      >
        { hintBody }
      </Dialog>
    </div>
  );
};
